import classNames from 'classnames';
import React from 'react';

function _renderLines (lines: string []): React.ReactNode[] {
  let renderedLines: React.ReactNode[] = [];

  renderedLines.push(<span key='line_0'>{lines[0]}</span>);
  for (let lineIndex = 1; lineIndex < lines.length; lineIndex++) {
    renderedLines.push(<br key={'br_' + lineIndex} />);
    renderedLines.push(<span key={'line_' + lineIndex}>{lines[lineIndex]}</span>);
  }
  return renderedLines;
}

type Props = {
  text: string,
  className?: string
};

class WarningPanel extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    const { text, className } = this.props;

    const lines: string[] = text.split('<br>');

    return (
      <div className={classNames('esko_alert esko_alert-warning esko_warning', className)} role='alert'>
        <span className='bi bi-exclamation-triangle-fill' aria-hidden='true' />
        <div>
          <span className='sr-only'>Warning:</span>{' '}{_renderLines(lines)}
        </div>
      </div>
    );
  }
}

export default WarningPanel;
